import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { Loader2, ShieldCheck } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { Logo } from '@/components/Logo';
import PageHead from '@/components/PageHead';
import { adminLogin } from '@/lib/api';

export default function AdminLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  if (localStorage.getItem('alofisa_token')) {
    return <Navigate to="/admin" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await adminLogin(email.toLowerCase().trim(), password);
      localStorage.setItem('alofisa_token', res.token);
      localStorage.setItem('alofisa_admin_email', res.email);
      toast.success('Connecté');
      navigate('/admin');
    } catch (err) {
      toast.error('Identifiants incorrects');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background hero-bg noise-overlay px-4 relative" data-testid="admin-login-page">
      <PageHead title="Connexion admin" />
      <Card className="w-full max-w-md p-8 rounded-2xl border-border bg-white relative z-10">
        <div className="flex flex-col items-start gap-3">
          <Logo size="md" />
          <h1 className="font-heading text-2xl font-semibold tracking-tight mt-3">Espace administration</h1>
          <p className="text-sm text-muted-foreground">Accédez à la gestion des demandes de devis et messages.</p>
        </div>
        <form onSubmit={onSubmit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1" data-testid="admin-email-input" required />
          </div>
          <div>
            <Label htmlFor="password">Mot de passe</Label>
            <Input id="password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1" data-testid="admin-password-input" required />
          </div>
          <Button type="submit" disabled={submitting} className="w-full rounded-xl" data-testid="admin-login-submit-button">
            {submitting && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}<ShieldCheck className="w-4 h-4 mr-2" />Se connecter
          </Button>
        </form>
      </Card>
    </div>
  );
}
